import {OfferType} from "../../../common/app/routing/offer_type";

export const appendOfferTypeParams = (params: URLSearchParams, offerType: OfferType) => {
    (offerType === OfferType.PROPERTY || offerType === OfferType.FLAT) && params.append("type", "1");
    (offerType === OfferType.PROPERTY || offerType === OfferType.HOUSE) && params.append("type", "2");
};
